import React from "react";
import { CommissionAdminValues, CommissionValues, FetchResponse } from '../types'
import Commission from '../components/Commission/Commission'
import EventEmitter from 'events'

const defaultCommissionValues: CommissionValues = {
  commissionFile: null,
  handleClearInputFile: () => null,
  handleFileUpload: (file: File | null) => null,
  handleSetToastOptions:  (data: FetchResponse) => null,
  commissionResponse: undefined,
  handleCommissionResponse: (commissionResponse: Commission[]) => null
}

const defaultValue: CommissionAdminValues = {
  isUnauthorized: false,
  handleAuthorization: () => null,
  commissionValues: defaultCommissionValues,
  eventEmitter: new EventEmitter(),
}

const CommissionAdminContext = React.createContext(defaultValue);

export default CommissionAdminContext;
